import { URLS } from '../factories'
import type { DotCMSPageComponent } from '@/types/global';
import { useConfigStore } from '@/stores/modules/configStore';
export default {
    async getContentById (id: string, depth = 1) {
      return new Promise(async (resolve, reject) => {
        const configStore = useConfigStore();
        const isProduction = configStore.isProduction;
        
        const requestURL = isProduction ? URLS.production.dotCMSApiUrl : URLS.replica.dotCMSApiUrl
        const url = requestURL + `/api/content/id/${id}/depth/${depth}`
        
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000);

        try {
          const response = await fetch(url, {
            signal: controller.signal
          });
          
          clearTimeout(timeoutId);

          // Check if the response is OK
          // Send back the page contents array as one json of page component e.g. contentlets[0].pageContents
          if (response.ok) {
            const data = await response.json() as DotCMSPageComponent
            if (!data.contentlets || !data.contentlets[0].pageContents) {
              reject('No content found')
            } else {
              resolve(data.contentlets[0].pageContents)
            }
          } else {
            reject(response.statusText)
          }
        } catch (error) {
          clearTimeout(timeoutId);
          reject(error);
        }
      })
    }
}